'use strict';

const ContentUtils = require('utils/ContentUtils'),
    KEY_TANK = 'cache_tanks',
    Notification = require('components/Notification/Notification'),
    {t} = require('services/i18nextWrapper'),
    _ = require('lodash');

let DashboardLayoutStore = {

    /**
     * Contain the list of positions, at UI level, that indicate where the orders are renderer
     * in the dashboard.
     */
    currentLayout: [],

    getTankTypeByPositionX(positionX) {
        const tanks = ContentUtils.sortTanksAndAddColumn(ContentUtils.getSession(KEY_TANK)) || [];
        const tankTarget = _.find(tanks, tank => _.get(tank, 'column') === positionX);
        return _.get(tankTarget, 'type');
    },
    /**
     * Update single position in the layout, remove old position and put the new one.
     * @param {Object} newPosition the position that will be updated in the dashboard.
     */
    updateSingleLayoutPosition(newPosition) {
        var newLayout = this.currentLayout.filter(function (box) {
            return ContentUtils.cleanId(box.i) !== ContentUtils.cleanId(newPosition.i);
        }.bind(this));
        this.currentLayout = newLayout;
        this.currentLayout.push(newPosition);
    },

    removeByOrderId(orderId) {
        this.currentLayout = _.filter(this.currentLayout, position => ContentUtils.cleanId(position.i) !== ContentUtils.cleanId(orderId));
    },

    push(position) {
        this.currentLayout.push(position);
    },

    getLayout() {
        return this.currentLayout;
    },

    setLayout(newLayout) {
        this.currentLayout = newLayout;
    },

    cleanLayout() {
        this.currentLayout = [];
    },

    /**
     * Update position in the layout, remove old position and put the new one.
     * @param {Object} newPosition the position that will be updated in the dashboard.
     * @param {Object} newPositionTwo the position that will be updated in the dashboard.
     */
    updateLayoutPosition(newPosition, newPositionTwo) {
        if (newPosition && newPositionTwo) {
            this.currentLayout = _.filter(this.currentLayout, box => ContentUtils.cleanId(box.i) !== ContentUtils.cleanId(newPosition.i));
            this.currentLayout.push(newPosition);
            this.currentLayout.push(newPositionTwo);
        }
    },

    /**
     * Update positions in the layout, remove old position and put the new one.
     */
    updateLayoutPositions() {
        const amountPositions = _.get(arguments, 'length', 0);
        if (amountPositions > 0) {
            // remove all old positions
            this.currentLayout = _.filter(this.currentLayout, box => ContentUtils.cleanId(box.i) !== ContentUtils.cleanId(arguments[0].i));
            // add all new given positions
            const positions = _.flatten(arguments);

            _.forEach(positions, newPosition => {
                this.currentLayout.push(newPosition);
            });
        }
    },

    updateLayoutPositionBySpecificId(newPosition) {
        if (newPosition) {
            this.currentLayout = _.filter(this.currentLayout, box => box.i !== newPosition.i);
            this.currentLayout.push(newPosition);
        }
    },

    setAsRelocatedPositions(batchNumber) {
        const positionsBatch = _.filter(this.currentLayout, position => position.batchNumber === batchNumber);
        const positionBatchUpdated = _.map(positionsBatch, position => {
            position.isRelocated = true;
            return position;
        });

        for (const position of positionBatchUpdated) {
            this.updateLayoutPositionBySpecificId(position);
        }
    },

    resetAllPositionAsRelocatedDone(batchNumber) {
        const positionsBatch = _.filter(this.currentLayout, position => position.batchNumber === batchNumber);
        const positionBatchUpdated = _.map(positionsBatch, position => {
            position.isRelocated = false;
            return position;
        });

        for (const position of positionBatchUpdated) {
            this.updateLayoutPositionBySpecificId(position);
        }
    },

    /**
     * Check against to dashboard layout if given <code>positionNew</code> produce collisions with another. In case that
     * exist collisions return the information about which order collision against given <code>positionNew</code>.
     *
     * @param {Object} positionNew          The position that will be checked against the current dashboard layout.
     * @param {Array}  dashboardLayout      (Optionally) The override layout dashboard. (by default we take the current dashboard layout)
     * @return {Array} Return the array of collisions positions.
     */
    getRangeCollisions(positionNew, layoutConsumer = this.getLayout()) {
        // Filter only the boxes that are in the column(`positionNew.x`) that we need to check.
        let boxesToValidate = _.filter(layoutConsumer, item => {
                // Filter conditions:
                // 1) Check if the position is a brewhouse batch.
                //      A) True: ask if are already re-located the brewhouse batch.
                //          A.1) Is already re-located, means that position whould take as ocuppied position.
                //          A.2) Is not already re-located, means that position are still free.
                // 2) The position is not brewhouse so:
                //      A) Check if the X (column of layout of dashboard) are the column that we want to filter,
                //      B) Check that are different position that currently try to find their collision. (Eg: is not valid
                //          collision if taking care the same order that try to find the collision).
                //      C) Check also that don't want to take as a collision orders which orders with the same batch number,
                //         because, if we have 2 order with same batch number, and are just in the same line, allways we recalculate
                //         one of the other to another 'empty' position
                const isBrewhouseBatch = ContentUtils.isBHBatch(item.i);

                if (isBrewhouseBatch && item.isRelocated) {
                    return item.x === positionNew.x &&
                        ContentUtils.cleanId(item.i) !== ContentUtils.cleanId(positionNew.i);
                }

                return item.x === positionNew.x &&
                    ContentUtils.cleanId(item.i) !== ContentUtils.cleanId(positionNew.i) &&
                    this.isDifferentBatchNumber(item.batchNumber, positionNew.batchNumber);

            }),
            ranges,
            rangeNew,
            conflictRanges;

        if (boxesToValidate && boxesToValidate.length === 0) {
            return [];
        }

        ranges = this.getExistingRanges(boxesToValidate);

        rangeNew = {
            from: positionNew.y,
            to: (positionNew.h + positionNew.y) - 1,
            i: positionNew.i
        };

        conflictRanges = [];

        _.forEach(ranges, obj => {
            if (rangeNew.from <= obj.to && rangeNew.to >= obj.from) {
                conflictRanges.push({
                    rangeNew: rangeNew,
                    rangeConflict: obj
                });
            }
        });

        return conflictRanges;
    },

    isDifferentBatchNumber(batchNumberOne, batchNumberTwo) {
       const batchNumberOneText = String(batchNumberOne);
       const batchNumberTwoText = String(batchNumberTwo);

       if (batchNumberOneText === 'undefined' || batchNumberTwoText === 'undefined') {
           return true;
       }

       return batchNumberOneText !== batchNumberTwoText;
    },

    /**
     * Check if the given position have available space in the dashboard.
     * @param {Object} positionNew   The position that will be validate their availability space.
     * @return {Boolean}
     */
    isEmpty(positionNew, layoutConsumer = this.getLayout()) {
        var conflicRanges = this.getRangeCollisions(positionNew, layoutConsumer);
        return conflicRanges.length === 0;
    },

    /**
     * Validate if the order have an empty position in the dashboard.
     * @param {Object} order that will be under validation of
     *                          availability space on the dashboard.
     */
    isEmptyPositions(order, positionBriteTank, positionFermenterTank) {
        if (!this.isEmpty(positionBriteTank)) {
            Notification.show(t('dashboard_notification_brite_tank_position_occupied'));
            return false;
        }

        if (!this.isEmpty(positionFermenterTank)) {
            Notification.show(t('dashboard_notification_tank_position_occupied'));
            return false;
        }

        return true;
    },

    getExistingRanges(boxes) {
        return _.map(boxes, box => {
            return {
                from: box.y,
                to: box.y + box.h - 1,
                id: box.i
            };
        });
    },
    
    /**
     * There is not way to be valid to change high and y (vertical position) at the same time.
     * @param positionNew
     * @param positionOld
     * @returns {boolean|boolean}
     */
    isInvalidMovement(positionNew, positionOld) {
        const isDifferentY = _.get(positionNew, 'y') !== _.get(positionOld, 'y');
        const isDifferentH = _.get(positionNew, 'h') !== _.get(positionOld, 'h');
        return isDifferentH && isDifferentY;
    }
};

module.exports = DashboardLayoutStore;



/** WEBPACK FOOTER **
 ** ./src/stores/DashboardLayoutStore.js
 **/